/* eslint-disable react/no-deprecated */
import { Component } from 'react';

class TeamMetricTable extends Component {
  netDifference(value) {
    return value > 0 ? 'pos' : 'neg';
  }

  formatValue(value, index) {
    if (value === null) return <div className="net none"></div>;

    const displayOptions = this.props.data.display_options;
    let display = Math.abs(value).toFixed(displayOptions.decimal_places);

    value = value.toFixed(displayOptions.decimal_places);

    if (displayOptions.is_percent) display += '%';

    if (index === 0)
      return <div className="currentScore spec-score">{display}</div>;
    if (value == 0) return <div className="net none">{display}</div>;
    return (
      <div className={`net ${this.netDifference(value)}`}>
        <span>{display}</span>
      </div>
    );
  }

  render() {
    return (
      <table
        className="metricTable"
        data-inversepositive={
          this.props.data.display_options.positive_downward_trend
        }
      >
        <tbody>
          <tr className="widgetRow widgetHeader">
            {this.props.data.columns.map((label, index) => (
              <th className="widgetCell" key={`cell-${index}`}>
                {index !== 0 ? <div className="title">{label}</div> : ''}
              </th>
            ))}
          </tr>

          <tr className="widgetRow overallData">
            {this.props.data.overall.data.map((value, dsIndex) => (
              <td className="widgetCell" key={`cell-${dsIndex}`}>
                <span>
                  {this.formatValue(value, dsIndex)}
                  {dsIndex === 0 ? (
                    <div className="title">{this.props.data.overall.label}</div>
                  ) : (
                    ''
                  )}
                </span>
              </td>
            ))}
          </tr>

          {this.props.data.datasets.map((ds, index) => (
            <tr
              className={`widgetRow channelData ${
                this.props.hasChannelDataPerMember ? 'cursor-pointer' : ''
              }`}
              key={`row-${index}`}
              data-channel={ds.label}
              onClick={this.props.handler}
              data-target=".js-team-channel-drill"
              data-toggle="modal"
            >
              {ds.data.map((value, dsIndex) => (
                <td className="widgetCell" key={`cell-${dsIndex}`}>
                  <span>
                    {this.formatValue(value, dsIndex)}
                    {dsIndex === 0 ? (
                      <div className="title">{ds.label}</div>
                    ) : (
                      ''
                    )}
                  </span>
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    );
  }
}

export default TeamMetricTable;
/* eslint-enable react/no-deprecated */
